import React from 'react';
import EmptyState, { emptyStateIllustrationSize } from '@weave-mui/empty-state';
import Illustration, { illustrationVariants } from '@weave-mui/illustration';
import Button, { buttonVariants } from '@weave-mui/button';

/**
 * ManageTestDataEmptyState
 *
 * Empty state shown when a test case has no custom test data fields yet
 * (i.e., only `_name` and `_tags` are present).
 *
 * @param {Object} props
 * @param {Function} props.onAddFields - Callback invoked when user clicks "Add fields"
 * @returns {JSX.Element}
 */
const ManageTestDataEmptyState = ({ onAddFields }) => {
  return (
    <EmptyState
      headline="No fields yet"
      illustration={<Illustration variant={illustrationVariants.FIRST_USE} />}
      tagline="Add fields to start managing test data."
      callToAction={
        <Button variant={buttonVariants.CONTAINED} onClick={onAddFields}>
          Add fields
        </Button>
      }
      illustrationSize={emptyStateIllustrationSize.MEDIUM}
      sx={{
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '16px',
        marginBottom: '16px',
        width: '100%',
        maxWidth: '1086px',
      }}
    />
  );
};

export default ManageTestDataEmptyState;

